import { render, staticRenderFns } from "./SignUpVerification.vue?vue&type=template&id=d6799ab0&scoped=true"
import script from "./SignUpVerification.vue?vue&type=script&lang=js"
export * from "./SignUpVerification.vue?vue&type=script&lang=js"
import style0 from "./SignUpVerification.vue?vue&type=style&index=0&id=d6799ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6799ab0",
  null
  
)

export default component.exports